import { authClient } from '@/lib/auth-client.ts';
import { Box, Button, Group, Text } from '@mantine/core';
import { UserSwitchIcon } from '@phosphor-icons/react';
import { useMutation } from '@tanstack/react-query';
import { reloadForIdentityChange } from '@/common/auth/session-navigation.ts';

export default function ImpersonationBanner({
  height,
  name,
  email,
}: {
  height: number;
  name: string;
  email: string;
}) {
  const stopImpersonating = useMutation({
    mutationKey: ['admin', 'stop-impersonating'],
    mutationFn: async () => {
      const { error } = await authClient.admin.stopImpersonating();
      if (error) throw error;
    },
    onSuccess: () => reloadForIdentityChange('/admin/users'),
  });

  return (
    <Box
      role="status"
      style={{
        height,
        backgroundColor: 'var(--mantine-color-orange-light)',
        color: 'var(--mantine-color-orange-light-color)',
        borderBottom: '1px solid var(--mantine-color-orange-outline)',
      }}
    >
      <Group h="100%" px="sm" gap="sm" justify="center" wrap="nowrap">
        <UserSwitchIcon size={16} weight="fill" aria-hidden />
        <Text size="sm" fw={600} truncate>
          Impersonating {name || email} ({email})
        </Text>
        <Button
          size="compact-xs"
          color="orange"
          variant="filled"
          loading={stopImpersonating.isPending}
          onClick={() => stopImpersonating.mutate()}
        >
          End impersonation
        </Button>
      </Group>
    </Box>
  );
}
